import { EntregaRetiradaBaseDirective } from '@vip/container/entrega-retirada';
import { TelevendasFacade } from '@vip/state/televendas';
import {
  TipoEntregaFacade,
  TipoEntregaUtilsService,
} from '@vip/state/tipo-entrega';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EnderecoFacade } from '@vip/state/endereco';
import { ClienteFacade } from '@vip/state/cliente';
import { CentroDistribuicaoFacade } from '@vip/state/centro-distribuicao';
import { CepFacade } from '@vip/state/cep';
import { DialogService, ModalService } from '@vip/ui/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { ValidarCepContainerService } from '@vip/container/validar-cep';
import { FilialFacade } from '@vip/state/filial';
import { CompraEmProcessoFacade } from '@vip/state/compra-em-processo';
import { CarrinhoFacade } from '@vip/state/carrinho';
import { IMessage, MessageService } from '@vip/ui/message';
import { CodeScannerService } from '@vip/native/code-scanner';
import {
  FormaEntregaEnum,
  IHorariosFormatados,
  ITipoEntrega,
  ITipoEntregaCompra,
  LayoutUtilsService,
} from '@vip/core';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { untilDestroyed } from '@ngneat/until-destroy';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import { TipoEntregaApiService } from '@vip/api';

@Component({
  selector: 'vip-validar-prazo-entrega-container',
  templateUrl: './validar-prazo-entrega-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ValidarPrazoEntregaContainerComponent
  extends EntregaRetiradaBaseDirective
  implements OnInit, AfterViewInit, OnDestroy
{
  loadingEnderecos$ = this.enderecoFacade.loading$;
  loadingTipoEntrega$ = this.tipoEntregaFacade.loading$;
  horarioSelecionado$ = this.tipoEntregaFacade.horarioSelecionado$;
  isTelevendas$ = this.televendasFacade.isTelevendas;
  tiposEntregas$ = this.isTelevendas$
    ? this.tipoEntregaFacade.tiposEntregasTelevendas$
    : this.tipoEntregaFacade.tiposEntregas$;

  taxaEntrega$ = this.tipoEntregaFacade.tipoEntregaSelecionado$.pipe(
    map((tipoEntregaSelecionado) => {
      if (!tipoEntregaSelecionado) return undefined;
      return tipoEntregaSelecionado.frete - tipoEntregaSelecionado.desconto;
    }),
  );
  taxaServico$ = this.compraEmProcessoFacade.taxaServico$;
  tipoEntregaSelecionado$ = this.tipoEntregaFacade.tipoEntregaSelecionado$;
  compraEmProcesso$ = this.compraEmProcessoFacade.compraEmProcesso$;

  migrarCdIsRunning = false;
  exibirTiposEntrega$?: Observable<boolean>;
  exibirTiposRetirada$?: Observable<boolean>;

  disablePagamentoButton = false;
  formaEntregaEnum = FormaEntregaEnum;
  hasValidaPrazo = true;
  horarioSelecionado?: IHorariosFormatados;
  loadingTipoEntrega: boolean | null = false;
  hasTipoRetiradaPrazoEntrega: boolean | null = false;
  loadingTipoRetirada: boolean | null = false;
  tipoEntrega: boolean | undefined = false;
  entregaRetirada: boolean | undefined = false;
  frete!: number | undefined;
  tipoEntregaSelected: ITipoEntrega | null = null;
  private destroy$ = new Subject<void>();
  @Input() loading$?: Observable<boolean>;

  horarioFixo: IHorariosFormatados | null = null;

  @Output() confirm = new EventEmitter();
  desativarConfirmar = false;
  hasErroOpen = false;

  constructor(
    enderecoFacade: EnderecoFacade,
    cdFacade: CentroDistribuicaoFacade,
    cepFacade: CepFacade,
    clienteFacade: ClienteFacade,
    tipoEntregaFacade: TipoEntregaFacade,
    changeDetector: ChangeDetectorRef,
    dialogService: DialogService,
    router: Router,
    navController: NavController,
    activatedRoute: ActivatedRoute,
    validarCepContainerService: ValidarCepContainerService,
    filialFacade: FilialFacade,
    compraEmProcessoFacade: CompraEmProcessoFacade,
    carrinhoFacade: CarrinhoFacade,
    messageService: MessageService,
    codeScannerService: CodeScannerService,
    modalService: ModalService<unknown>,
    televendasFacade: TelevendasFacade,
    layoutUtilsService: LayoutUtilsService,
    private tipoEntregaUtilsService: TipoEntregaUtilsService,
  ) {
    super(
      enderecoFacade,
      cdFacade,
      cepFacade,
      clienteFacade,
      tipoEntregaFacade,
      filialFacade,
      compraEmProcessoFacade,
      carrinhoFacade,
      changeDetector,
      dialogService,
      router,
      navController,
      activatedRoute,
      validarCepContainerService,
      false,
      modalService,
      televendasFacade,
      layoutUtilsService,
      messageService,
      codeScannerService,
    );

    this.horarioSelecionado$
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        this.horarioSelecionado = response;
      });
  }

  ngOnInit(): void {
    this.loading$?.pipe(untilDestroyed(this)).subscribe((isLoading) => {
      this.loadingTipoRetirada = isLoading;
    });

    this.tipoEntregaSelecionado$
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        if (response) {
          this.tipoEntregaFacade.getHorarios();
        }
      });

    this.tipoEntregaSelected = null;
    this.setValuesExibirTipoEntregasListeners();
    this.tipoEntregaUtilsService.isLoadingTiposEntregasEnderecoRequest$
      .pipe(
        untilDestroyed(this),
        takeUntil(this.destroy$),
        tap((isLoading) => {
          if (!isLoading) {
            this.destroy$.next();
            this.destroy$.complete();
            this.loadingTipoEntrega = false;
          }
        }),
      )
      .subscribe((isLoading) => {
        this.loadingTipoEntrega = isLoading;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.compraEmProcesso$
      .pipe(untilDestroyed(this))
      .subscribe((compraEmProcesso) => {
        this.entregaRetirada = compraEmProcesso?.tipo_entrega.retirada;
      });
    this.changeDetector.detectChanges();
  }

  private setValuesExibirTipoEntregasListeners(): void {
    this.exibirTiposEntrega$ = combineLatest([
      this.enderecoFacade.enderecoEntrega$,
      this.isEntrega$,
    ]).pipe(
      untilDestroyed(this),
      map(([enderecoEntrega, isEntrega]) => {
        return isEntrega && !!enderecoEntrega;
      }),
    );
    this.exibirTiposRetirada$ = combineLatest([
      this.cdFacade.enderecoRetiradaCdSelecionado$,
      this.isEntrega$,
    ]).pipe(
      untilDestroyed(this),
      map(([enderecoRetirada, isEntrega]) => {
        return !isEntrega && !!enderecoRetirada;
      }),
    );
  }

  getTiposEntregasByCdChange(): void {
    if (this.migrarCdIsRunning) return;
    this.migrarCdIsRunning = true;
    combineLatest([this.cdFacade.migrarCDResponseSuccess$])
      .pipe(untilDestroyed(this), take(1))
      .subscribe(() => {
        this.migrarCdIsRunning = false;
        this.tipoEntregaFacade.getTiposEntregasEndereco();
      });
  }

  changeSelectTipoEntrega(event: ITipoEntregaCompra) {
    if (event && typeof event.id === 'number') {
      this.tipoEntregaSelected = event as ITipoEntrega;
      this.tipoEntregaFacade.resetHorarioSelecionado();
      this.tipoEntregaSelected = {
        ...this.tipoEntregaSelected,
        horario_selecionado: undefined,
      };
      this.compraEmProcesso$
        .pipe(untilDestroyed(this), take(1))
        .subscribe((response) => {
          if (
            this.tipoEntregaSelected &&
            this.tipoEntregaSelected.bloqueios?.length === 0
          ) {
            if (this.tipoEntregaSelected.horarios_formatados.length === 0) {
              if (response && this.tipoEntregaSelected?.tipo_entrega_id) {
                this.tipoEntregaFacade
                  .getHorariosFromService(
                    response.filial_id,
                    response.centro_distribuicao_id,
                    this.tipoEntregaSelected?.tipo_entrega_id,
                    this.tipoEntregaSelected,
                  )
                  .pipe(untilDestroyed(this), take(1))
                  .subscribe((horarios) => {
                    this.tipoEntregaSelected = {
                      ...this.tipoEntregaSelected,
                      horarios_formatados: horarios,
                    } as ITipoEntrega;
                  });
              }
            }
          }

          if (
            this.tipoEntregaSelected?.quantidade_maxima_itens !== undefined &&
            this.tipoEntregaSelected?.quantidade_maxima_itens !== null
          ) {
            if (
              response &&
              response.total_itens >
                (this.tipoEntregaSelected.quantidade_maxima_itens || 0)
            ) {
              const messageData: IMessage = {
                icon: 'icon-close',
                position: 'top',
                type: 'error',
              };
              this.messageService?.openMessage(
                messageData,
                'Você excedeu o limite de itens permitidos para esse tipo de entrega.',
                5.0,
              );

              this.desativarConfirmar = true;

              this.tipoEntregaSelected = {
                ...this.tipoEntregaSelected,
                horarios_formatados: [],
              } as ITipoEntrega;

              if (this.tipoEntregaSelected.horarios_formatados.length === 0) {
                this.hasErroOpen = true;
              }

              if (this.isDesktop) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              return;
            }
          } else {
            this.desativarConfirmar = false;
          }
        });

      this.frete = event.frete - (event.desconto || 0);

      if (event) {
        this.hasTipoRetiradaPrazoEntrega = true;
      }
    }
  }

  changeHorarioTipoEntrega(event: IHorariosFormatados) {
    this.handleHorarioChange(event);
  }

  handleHorarioChange(horarioSelecionado: IHorariosFormatados) {
    this.horarioSelecionado = horarioSelecionado;
    this.horarioFixo = horarioSelecionado;
    this.disablePagamentoButton = false;
  }

  confirmarPrazoEntrega() {
    this.tipoEntregaFacade.selectHorarioTipoEntrega(
      this.horarioSelecionado as IHorariosFormatados,
    );
    if (this.tipoEntregaSelected) {
      this.tipoEntregaFacade.selectTipoEntrega(this.tipoEntregaSelected.id);
      if (this.horarioFixo)
        this.tipoEntregaFacade.selectHorarioTipoEntrega(this.horarioFixo);
      this.compraEmProcessoFacade.setTipoEntrega(
        this.tipoEntregaSelected,
        this.horarioSelecionado,
      );
    }
    this.compraEmProcessoFacade.setFrete(this.frete);
    this.confirm.emit();
  }
}
